export default {
  empty: "请填写完整",
  fuzhicg: "复制成功",
  fuzhicc: "复制出现异常",
  login: {
    title: "SYSTEM LOGIN",
    logIn: "Login",
    username: "Account",
    password: "Password",
  },
  wrongpwd: "字母大小写+数字不能低于8位，暂不支持使用特殊符号",
  首页: "首页",
  行情: "行情",
  财富: "财富",
  我的: "我的",
  忘记密码: "忘记密码",
  确定: "确定",
  "忘记密码？": "忘记密码？",
  登录: "登录",
  注册: "注册",
  云端钱包: "云端钱包",
  世界顶尖安全保护: "世界顶尖安全保护",
  "独有资产增益，注册存币坐享收益": "独有资产增益，注册存币坐享收益",
  "支持超过30+主流币和500+代币": "支持超过30+主流币和500+代币",
  HD钱包: "HD钱包",
  "100%掌管私钥，资产更放心": "100%掌管私钥，资产更放心",
  "一键导入助记词，方便好用": "一键导入助记词，方便好用",
  设置登录密码: "设置登录密码",
  确认: "确认",
  手机注册: "手机注册",
  已有账号: "已有账号",
  去登录: "去登录",
  最近流行: "最近流行",
  全部: "全部",
  拖动排序: "拖动排序",
  立即创建: "立即创建",
  您支付: "您支付",
  可换余额: "可换余额",
  请在以下时间内完成支付以锁定此汇率: "请在以下时间内完成支付以锁定此汇率",
  您获得: "您获得",
  "您获得的币种为空时,说明没有币种可以闪兑。":
    "您获得的币种为空时,说明没有币种可以闪兑。",
  立即兑换: "立即兑换",
  备份钱包助记词: "备份钱包助记词",
  "1.由12个字符组成，请抄写并保管在安全的地方。":
    "1.由12个字符组成，请抄写并保管在安全的地方。",
  "2.100%由您保管，一经丢失，无法找回。":
    "2.100%由您保管，一经丢失，无法找回。",
  "3.请在收币或卸载之前，务必完成助记词备份。":
    "3.请在收币或卸载之前，务必完成助记词备份。",
  立即备份: "立即备份",
  "我先看看，稍后再说": "我先看看，稍后再说",
  请环顾四周: "请环顾四周",
  "任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。":
    "任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。",
  知道了: "知道了",
  请输入验证码: "请输入验证码",
  "没有收到验证码？": "没有收到验证码？",
  交易时间: "交易时间",
  交易ID: "交易ID",
  来自: "来自",
  发送到: "发送到",
  备注: "备注",
  发送: "发送",
  闪兑: "闪兑",
  接收: "接收",
  交易记录: "交易记录",
  "正在刷新...": "正在刷新...",
  "正在加载...": "正在加载...",
  暂无相关记录: "暂无相关记录",
  重新设置支付密码: "重新设置支付密码",
  "请将上方的16位恢复秘钥备份在安全的地方，遗失秘钥将无法恢复两步验证":
    "请将上方的16位恢复秘钥备份在安全的地方，遗失秘钥将无法恢复两步验证",
  我已设置并备份秘钥: "我已设置并备份秘钥",
  "谷歌验证可以为您的账户增加一层保护，当您登录或者进行交易时，再输密码的同时，还需要来自谷歌验证的验证码":
    "谷歌验证可以为您的账户增加一层保护，当您登录或者进行交易时，再输密码的同时，还需要来自谷歌验证的验证码",
  "如何使用谷歌两步验证?": "如何使用谷歌两步验证?",
  筛选: "筛选",
  移除: "移除",
  添加: "添加",
  总资产: "总资产",
  创建钱包: "创建钱包",
  导入钱包: "导入钱包",
  邀请好友: "邀请好友",
  发红包: "发红包",
  扫一扫: "扫一扫",
  地址簿: "地址簿",
  历史公告: "历史公告",
  设置: "设置",
  请选择您的证件的颁发国家: "请选择您的证件的颁发国家",
  查看助记词: "查看助记词",
  "您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。":
    "您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。",
  "请勿截图！如果有人获取你的助记词将直接获取你的资产！":
    "请勿截图！如果有人获取你的助记词将直接获取你的资产！",
  查看加密二维码: "查看加密二维码",
  "加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。":
    "加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。",
  "该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。":
    "该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。",
  "请抄写 HMC Wallet Pro 助记词": "请抄写 HMC Wallet Pro 助记词",
  "HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。":
    "HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。",
  我已安全保存: "我已安全保存",
  "HMC Wallet Pro需要您提政府颁发的照片ID来通过安全验证":
    "HMC Wallet Pro需要您提政府颁发的照片ID来通过安全验证",
  提交: "提交",
  设置收款金额: "设置收款金额",
  收款金额: "收款金额",
  复制收款码: "复制收款码",
  取消: "取消",
  数量: "数量",
  "为了您的账户安全,请输入原支付密码确认身份。":
    "为了您的账户安全,请输入原支付密码确认身份。",
  "忘记支付密码?": "忘记支付密码?",
  将配好的红包分享给好友: "将配好的红包分享给好友",
  个: "个",
  "请确认 HMC Wallet Pro 助记词": "请确认 HMC Wallet Pro 助记词",
  "为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。":
    "为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。",
  "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。":
    "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。",
  恢复助记词钱包: "恢复助记词钱包",
  "请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词":
    "请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词",
  开始恢复: "开始恢复",
  "覆盖当前钱包？": "覆盖当前钱包？",
  "导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。":
    "导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。",
  继续导入: "继续导入",
  全部发送: "全部发送",
  交易费: "交易费",
  慢: "慢",
  快: "快",
  已有红包: "已有红包",
  生成红包: "生成红包",
  确认支付: "确认支付",
  可在已有红包页面查看领取详情: "可在已有红包页面查看领取详情",
  级: "级",
  退出登录: "退出登录",
  全部划转: "全部划转",
  查看规则: "查看规则",
  请输入支付密码: "请输入支付密码",
  币计划活期: "币计划活期",
  币计划定期: "币计划定期",
  预期年化收益: "预期年化收益",
  我的财富: "我的财富",
  币计划: "币计划",
  热门推荐: "热门推荐",
  交易查询: "交易查询",
  财富资产: "财富资产",
  累计收益: "累计收益",
  预期年化收益率: "预期年化收益率",
  交易规则: "交易规则",
  买入: "买入",
  起息日: "起息日",
  到期日: "到期日",
  产品亮点: "产品亮点",
  剩余额度: "剩余额度",
  立即购买: "立即购买",
  昨日收益: "昨日收益",
  划入: "划入",
  划出: "划出",
  全部划出: "全部划出",
  请输入谷歌二次验证码: "请输入谷歌二次验证码",
  点击登录: "点击登录",
  "欢迎来到HMC Wallet Pro": "欢迎来到HMC Wallet Pro",
  邀请奖励: "邀请奖励",
  每日快讯: "每日快讯",
  联系客服: "联系客服",
  邀请累计: "邀请累计",
  积分: "积分",
  好友注册人数: "好友注册人数",
  好友注册: "好友注册",
  人数: "人数",
  一级好友数: "一级好友数",
  "积分 每人奖励": "积分 每人奖励",
  二级好友数: "二级好友数",
  三级好友数: "三级好友数",
  一级好友数2: "一级好友数",
  二级好友数2: "二级好友数",
  三级好友数2: "三级好友数",
  "积分 每人奖励2": "积分 每人奖励",
  好友存币数: "好友存币数",
  邀请列表: "邀请列表",
  邀请注册: "邀请注册",
  邀请存币: "邀请存币",
  暂时没有邀请哦: "暂时没有邀请哦",
  当前总额: "当前总额",
  积分账单: "积分账单",
  任务: "任务",
  商城: "商城",
  "忘记PIN码？备份钱包后重新安装App并导入助记词后重置":
    "忘记PIN码？备份钱包后重新安装App并导入助记词后重置",
  "为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。":
    "为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。",
  "PIN码为本地密码，请妥善保存，如果丢失，无法恢复":
    "PIN码为本地密码，请妥善保存，如果丢失，无法恢复",
  关闭PIN码: "关闭PIN码",
  "扫码下载HMC Wallet Pro": "扫码下载HMC Wallet Pro",
  "邀请码(点击复制)": "邀请码(点击复制)",
  查看邀请详情: "查看邀请详情",
  我的订单: "我的订单",
  正在进行中: "正在进行中",
  已经结束: "已经结束",
  人参与: "人参与",
  兑换金额: "兑换金额",
  商品详情: "商品详情",
  兑换时间: "兑换时间",
  开始时间: "开始时间",
  结束时间: "结束时间",
  我的积分: "我的积分",
  我的剩余兑换额度: "我的剩余兑换额度",
  库存总量: "库存总量",
  剩余库存: "剩余库存",
  兑换比例: "兑换比例",
  确认兑换: "确认兑换",
  任务记录: "任务记录",
  分享: "分享",
  请填写手机号: "请填写手机号",
  验证码: "验证码",
  设置密码: "设置密码",
  再次输入: "再次输入",
  请填写密码: "请填写密码",
  邀请码: "邀请码",
  我的Dapp钱包: "我的Dapp钱包",
  发现: "发现",
  搜索: "搜索",
  自定义排序: "自定义排序",
  货币: "货币",
  创建新地址: "创建新地址",
  名称: "名称",
  地址: "地址",
  请输入金额: "请输入金额",
  验证您的身份: "验证您的身份",
  选择币种: "选择币种",
  设置支付密码: "设置支付密码",
  谷歌两步验证码: "谷歌两步验证码",
  谷歌两步验证: "谷歌两步验证",
  请输入搜索内容: "请输入搜索内容",
  选择证件类型: "选择证件类型",
  支付密码: "支付密码",
  修改支付密码: "修改支付密码",
  认证资料: "认证资料",
  国家: "国家",
  您的居住国家: "您的居住国家",
  姓名: "姓名",
  您的姓名全称: "您的姓名全称",
  生日: "生日",
  居住地: "居住地",
  您现在的居住地: "您现在的居住地",
  证件ID: "证件ID",
  您的证件ID号码: "您的证件ID号码",
  ID正面照片: "ID正面照片",
  ID反面照片: "ID反面照片",
  请输入数值: "请输入数值",
  已配置红包: "已配置红包",
  重置支付密码: "重置支付密码",
  红包详情: "红包详情",
  安全等级: "安全等级",
  请输入收款地址: "请输入收款地址",
  "备注(选填)": "备注(选填)",
  配置红包: "配置红包",
  金额: "金额",
  红包数: "红包数",
  请填写个数: "请填写个数",
  红包总额度: "红包总额度",
  红包数量: "红包数量",
  祝福语: "祝福语",
  选择发送途径: "选择发送途径",
  云端钱包设置: "云端钱包设置",
  账户名称: "账户名称",
  注册时间: "注册时间",
  请输入划入金额: "请输入划入金额",
  请输入转出金额: "请输入转出金额",
  谷歌二次验证: "谷歌二次验证",
  默认货币: "默认货币",
  PIN码: "PIN码",
  行情选项: "行情选项",
  服务协议: "服务协议",
  隐私政策: "隐私政策",
  帮助中心: "帮助中心",
  加入社群: "加入社群",
  加入社群2: "加入社群",
  我的邀请: "我的邀请",
  验证PIN码: "验证PIN码",
  设置PIN码: "设置PIN码",
  行情显示色选项: "行情显示色选项",
  请输入兑换金额: "请输入兑换金额",
  任务中心: "任务中心",
  快讯: "快讯",
  "已开启(重置)": "已开启(重置)",
  已开启: "已开启",
  未开启: "未开启",
  绿涨红跌: "绿涨红跌",
  红涨绿跌: "红涨绿跌",
  全部交易: "全部交易",
  增益收入: "增益收入",
  全部产品: "全部产品",
  全部币种: "全部币种",
  当前余额: "当前余额",
  钱包: "钱包",
  今日获得: "今日获得",
  "我已备份好当前钱包，同意覆盖": "我已备份好当前钱包，同意覆盖",
  备份助记词: "备份助记词",
  "助记词即为私钥，它是掌管您财产的钥匙":
    "助记词即为私钥，它是掌管您财产的钥匙",
  完成: "完成",
  下一步: "下一步",
  默认语言: "默认语言",
  "没有HMC Wallet Pro账号？": "没有HMC Wallet Pro账号？",
  获取验证码: "获取验证码",
  验证错误: "验证错误",
  验证成功: "验证成功",
  验证失败: "验证失败",
  设置成功: "设置成功",
  请选择同意: "请选择同意",
  云端钱包公告: "云端钱包公告",
  HD钱包公告: "HD钱包公告",
  云端钱包地址簿: "云端钱包地址簿",
  HD钱包地址簿: "HD钱包地址簿",
  收款地址: "收款地址",
  请填写完整: "请填写完整",
  复制成功: "复制成功",
  复制出现异常: "复制出现异常",
  资产名: "资产名",
  交易量: "交易量",
  价格: "价格",
  "涨跌幅(24H)": "涨跌幅(24H)",
  内部转账: "内部转账",
  外部转账: "外部转账",
  请输入收款用户ID: "请输入收款用户ID",
  邮箱注册: "邮箱注册",
  邮箱登录: "邮箱登录",
  手机登录: "手机登录",
  邮箱验证: "邮箱验证",
  手机验证: "手机验证",
  请填写邮箱号: "请填写邮箱号",
  公链: "公链",
  游戏: "游戏",
  我的游戏: "我的游戏",
  社区: "社区",
  链游: "链游",
  全部动态: "全部动态",
  热门游戏: "热门游戏",
  我的关注: "我的关注",
  发布: "发布",
  分享新鲜事: "分享新鲜事",
  发布动态: "发布动态",
  个人主页: "个人主页",
  全文: "全文",
  评论: "评论",
  赞: "赞",
  没有更多了: "没有更多了",
  暂无数据: "暂无数据",
  提示: "提示",
  请选择文件: "请选择文件",
  请输入动态内容: "请输入动态内容",
  确定删除该图片吗: "确定删除该图片吗",
  上传文件类型错误: "上传文件类型错误",
  请选择要上传的图片: "请选择要上传的图片",
  匿名用户: "匿名用户",
  收起: "收起",
  查看所有评论: "查看所有评论",
  确定删除该动态吗: "确定删除该动态吗",
  动态详情: "动态详情",
  删除: "删除",
  有趣的评论万里挑一: "有趣的评论万里挑一",
  请输入内容: "请输入内容",
  回复: "回复",
  暂无签名: "暂无签名",
  已关注: "已关注",
  关注: "关注",
  删除成功: "删除成功",
  打开: "打开",
  写下你的评论: "写下你的评论",
  个人资料: "个人资料",
  点击修改: "点击修改",
  昵称: "昵称",
  ID: "ID",
  手机号: "手机号",
  个性签名: "个性签名",
  添加图片或视频: "添加图片或视频",
  可用资产: "可用资产",
  锁定资产: "锁定资产",
  转账: "转账",
  收款: "收款",
  钱包管理: "钱包管理",
  锁仓截止日期: "锁仓截止日期",
  锁定: "锁定",
  交易所: "交易所",
  量化交易: "量化交易",
  角色信息: "角色信息",
  绑定角色: "绑定角色",
  服务区: "服务区",
  请选择服务区: "请选择服务区",
  角色: "角色",
  请选择角色: "请选择角色",
  绑定: "绑定",
  绑定成功: "绑定成功",
  立即绑定: "立即绑定",
  未绑定: "未绑定",
  MetaEx交易所: "MetaEx交易所",
  AI机器人: "AI机器人",
  邮箱注册: "邮箱注册",
  请填写邮箱号: "请填写邮箱号",
  返回首页: "返回首页",
  BTC公链: "BTC公链",
  ETH公链: "ETH公链",
  HMC公链: "HMC公链",
  HMC20: "HMC20",
  实名认证: "实名认证",
  请先设置支付密码: "请先设置支付密码",
  立即认证: "立即认证",
  已认证: "已认证",
  谷歌验证器: "谷歌验证器",
  两步验证: "两步验证",
  "如何使用谷歌验证器?": "如何使用谷歌验证器?",
  所有币种: "所有币种",
  已添加币种: "已添加币种",
  未添加币种: "未添加币种",
  邮箱: "邮箱",
  手机: "手机",
  获取: "获取",
  推荐: "推荐",
  利空: "利空",
  利好: "利好",
  请填写完整的助记词: "请填写完整的助记词",
  "不是正确的助记词,请重新输入": "不是正确的助记词,请重新输入",
  noequal: "两次输入不相等",
  invite: "请输入六位邀请码",
  旧密码: "旧密码",
  新密码: "新密码",
  立即修改: "立即修改",
  请确认新密码: "请确认新密码",
  请填写完整表单: "请填写完整表单",

  认证失败: "认证失败",
  修改密码: "修改密码",
  两次密码不一致: "两次密码不一致",
  待审核: "待审核",
  认证状态: "认证状态",
  身份认证失败: "身份认证失败",
  失败原因: "失败原因",
  重新认证: "重新认证",
  审核中: "审核中",
  已完成身份认证: "已完成身份认证",
  国籍: "国籍",
  类型: "类型",
  身份证: "身份证",
  护照: "护照",
  驾照: "驾照",
  证件号码: "证件号码",
  已完成实名认证: "已完成实名认证",
  身份验证: "身份验证",
  请输入手机验证码: "请输入手机验证码",
  发送验证码: "发送验证码 ",
  请输入邮箱验证码: "请输入邮箱验证码",
  请输入谷歌验证码: "请输入谷歌验证码",
  输入邮箱验证码: "输入邮箱验证码",
  输入手机验证码: "输入手机验证码",
  输入谷歌验证码: "输入谷歌验证码",
  谷歌验证: "谷歌验证",
  立即验证: "立即验证",
  发送验证码至手机: "发送验证码至手机",
  发送验证码至邮箱: "发送验证码至邮箱",
  忘记支付密码: "忘记支付密码",
  输入新密码: "输入新密码",
  请再次输入: "请再次输入",
  请输入密码: "请输入密码",
  请输入邮箱: "请输入邮箱",
  绑定邮箱: "绑定邮箱",
  请输入手机号: "请输入手机号",
  区号: "区号",
  请选择区号: "请选择区号",
  绑定手机号: "绑定手机号",
  可用余额不足: "可用余额不足",
  地址格式不正确: "地址格式不正确",
  金额不足10: "金额不足10",
  提币数量不能小于: "提币数量不能小于",
  "您还未进行实名认证,请先进行实名认证": "您还未进行实名认证，请先进行实名认证",
  至少为10: "至少为10",
  全选: "全选",
  删除: "删除",
  请先勾选地址: "请先勾选地址",
  新建地址: "新建地址",
  提币网络: "提币网络",
  收款网络: "收款网络",
  "操作成功!": "操作成功!",
  韩国: "韩国",
  日本: "日本",
  其他: "其他",
  请上传手持证件照片: "请上传手持证件照片",
  请把信息填写完整: "请把信息填写完整",
  请上传所需图片: "请上传所需图片",
  两步验证登录: "两步验证登录",
  请选择验证方式: "请选择验证方式",
  验证方式: "验证方式",
  验证登录: "验证登录",
  短信验证: "短信验证",
  证件类型: "证件类型",
  邮箱地址不符合格式: "邮箱地址不符合格式",
  下拉刷新: "下拉刷新",
  释放更新: "释放更新",
  修改个性签名: "修改个性签名",
  修改昵称: "修改昵称",
  导入NFT: "导入NFT",
  请输入NFT合约地址: "请输入NFT合约地址",
  请输入收藏品ID: "请输入收藏品ID",
  币种: "币种",
  添加收藏品: "添加收藏品",
  暂无NFT收藏: "暂无NFT收藏",
  确认删除此专辑吗: "确认删除此专辑吗",
  确认删除此收藏品吗: "确认删除此收藏品吗",
  编号: "编号",
  删除收藏品: "删除收藏品",
  保存收款码: "保存收款码",
  "没有HMC Wallet Pro账号？ 注册": "没有HMC Wallet Pro账号？ 注册",
  "已有账号，去登录": "已有账号，去登录",
  导入NFT: "导入NFT",
  接收地址: "接收地址",
  添加收藏品: "添加收藏品",
  暂无NFT收藏: "暂无NFT收藏",
  编号: "编号",
  删除: "删除",
  转出: "转出",
  确认删除此收藏品吗: "确认删除此收藏品吗",
  确认删除此专辑吗: "确认删除此专辑吗",
  地址: "地址",
  请输入NFT合约地址: "请输入NFT合约地址",
  请输入收藏品ID: "请输入收藏品ID",
  添加: "添加",
  NFT接收地址: "NFT接收地址",
  复制: "复制",
  此地址仅用于NFT钱包地址接收使用: "此地址仅用于NFT钱包地址接收使用",
  转出NFT: "转出NFT",
  合约地址: "合约地址",
  转出网络: "转出网络",
  藏品编号: "藏品编号",
  转出地址: "转出地址",
  "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。":
    "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。",
  请输入转出地址: "请输入转出地址",
  NFT历史记录: "NFT历史记录",
  时间: "时间",
  转入详情: "转入详情",
  已转出: "已转出",
  交易详情: "交易详情",
  发送地址: "发送地址",
  接收地址: "接收地址",
  网络: "网络",
  交易哈希: "交易哈希",
  NFT合约地址: "NFT合约地址",
  NFT编号: "NFT编号",
  交易时间: "交易时间",
};
